import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from 'src/hooks'
import { selectShowBadges, setShowBadges } from 'src/app/hostSettings'
import Toggle from '../Toggle'

const ShowBadges = () => {
  // obtain the initial state of showBadges
  const showBadges = useAppSelector(selectShowBadges)
  const dispatch = useAppDispatch()

  const onBadgeToggle = useCallback(
    (toggle: boolean) => dispatch(setShowBadges(toggle)),
    [dispatch]
  )

  return (
    <div className="mb-4">
      <div className="inline-flex pb-2 justify-between w-full">
        <p className="text-darkBlack mr-2">Display Badges to Participants</p>
        <Toggle onToggle={onBadgeToggle} initialState={showBadges} />
      </div>
      <p className="text-xs text-grey">
        If disabled, only the host will be able to view badges in the Badges App
        and on user videos
      </p>
    </div>
  )
}

export default ShowBadges
